import type { CardMetadata } from '../types/catalog';
import { isUnit } from '../types/catalog';
import { CardImage } from './CardImage';
import { CardTypeIcon } from './Icons';
import { AttackBadge, EnergyBadge, KindBadge, TypeBadge } from './Badges';

interface CardTileProps {
  card: CardMetadata;
  onClick: () => void;
}

/** Miniatura clicável de uma carta na grade. */
export function CardTile({ card, onClick }: CardTileProps): React.JSX.Element {
  return (
    <button type="button" className="card-tile" onClick={onClick}>
      <div className="card-art">
        <CardImage
          artUrl={card.artUrl}
          alt={card.name}
          glyph={<CardTypeIcon type={card.type} />}
        />
        <span className="cost-badge">
          <EnergyBadge cost={card.cost} />
        </span>
        {isUnit(card) && (
          <span className="attack-badge">
            <AttackBadge attack={card.baseAttack} />
          </span>
        )}
      </div>
      <div className="card-body">
        <h3 className="card-name">{card.name}</h3>
        {card.description && <p className="card-desc">{card.description}</p>}
        <div className="card-tags">
          <TypeBadge type={card.type} />
          {isUnit(card) && card.kinds.map((kind) => <KindBadge key={kind} kind={kind} />)}
        </div>
      </div>
    </button>
  );
}
